const formatCurrency = (money: number, symbol = 'XAF') => {
    // Add thousands separator
    const formattedNumber = money ? money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 0;
  
    // Format the number as a currency string
    return `${formattedNumber} ${symbol}`;
};

export { formatCurrency };